import { AdminMessage, AdminMessageDevice } from "store/api/adminMessagesApi"
import { ApiTypes, UITypes } from "types"

export type AdminMessageCenterDevice = ApiTypes.Model.VendorDevice & { messages: AdminMessage[] }

export const getAdminDeviceSearchParams = (params: UITypes.Params): UITypes.Params => {
  return {
    phisical_status: "installed",
    work_status: "online",
    ...(params.email ? { email: params.email } : {}),
    ...(params.sn || params.serial_number || params.thermostat_id
      ? { sn: params.sn || params.serial_number || params.thermostat_id }
      : {}),
    ...(params.homeowner || params.customer ? { homeowner: params.homeowner || params.customer } : {}),
    ...(params.contractor_name || params.contractor
      ? { contractor_name: params.contractor_name || params.contractor }
      : {}),
    ...(params.page ? { page: params.page } : {}),
    per_page: Number(params.perPage ?? params.per_page) || 50,
  }
}

export const combineAdminDevicesWithMessages = (
  adminDevices: ApiTypes.Model.VendorDevice[],
  messageDevices: AdminMessageDevice[],
): AdminMessageCenterDevice[] => {
  const messageDeviceById = new Map(messageDevices.map(device => [String(device.id), device]))
  const messageDeviceBySerialNumber = new Map(
    messageDevices.map(device => [device.serial_number.trim().toUpperCase(), device]),
  )

  return adminDevices.map(device => ({
    ...device,
    messages:
      messageDeviceById.get(String(device.id))?.messages ||
      messageDeviceBySerialNumber.get(device.sn.trim().toUpperCase())?.messages ||
      [],
  }))
}
